import { TextField, Box, Typography, Paper } from '@mui/material';
import FieldWrapper from '../FieldWrapper';
import AddressFields from '../AddressFields';

const NEED_EMPLOYER = ['Dipendente', 'Lavoratore Autonomo'];

export default function Step9Datore({ data, onChange, errors, metadata }) {
  const isRelevant = NEED_EMPLOYER.includes(data.attivita_lavorativa);
  const label = data.attivita_lavorativa === 'Lavoratore Autonomo' ? 'Attività / Sede professionale' : 'Datore di lavoro';

  if (!isRelevant) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>{label}</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
            In base alla tua occupazione ({data.attivita_lavorativa || 'non specificata'}), questa sezione non è necessaria.
          </Typography>
        </Box>
        <Paper variant="outlined" sx={{ p: 4, textAlign: 'center', borderRadius: 3, bgcolor: 'action.hover' }}>
          <Typography variant="body2" color="text.secondary">Puoi procedere al prossimo step</Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>{label}</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {data.attivita_lavorativa === 'Lavoratore Autonomo'
            ? 'Inserisci i dati della tua attività'
            : 'Inserisci i dati del tuo datore di lavoro'
          }
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FieldWrapper label="Ragione Sociale" error={errors?.datore_ragione_sociale} completed={!!data.datore_ragione_sociale}>
          <TextField fullWidth size="small" value={data.datore_ragione_sociale || ''} onChange={e => onChange('datore_ragione_sociale', e.target.value)} placeholder="Nome azienda o attività" />
        </FieldWrapper>

        <AddressFields prefix="datore" data={data} onChange={onChange} errors={errors} metadata={metadata} />

        <FieldWrapper label="Telefono" error={errors?.datore_telefono} completed={!!data.datore_telefono}>
          <TextField fullWidth size="small" type="tel" value={data.datore_telefono || ''} onChange={e => onChange('datore_telefono', e.target.value)} placeholder="Recapito telefonico" />
        </FieldWrapper>
      </Box>
    </Box>
  );
}